'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _CellInfoIconsBlock = require('./CellInfoIconsBlock.scss');var styles = _interopRequireWildcard(_CellInfoIconsBlock);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var CellInfoIconsBlock = function CellInfoIconsBlock(props) {return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.propertyInfoBlock, props.className), ref: props.innerRef || function () {} },
      props.rooms &&
      _react2.default.createElement('span', { property: 'numberOfRooms' },
        _react2.default.createElement('i', { className: 'icon icon-door', title: props.roomsIconTitle }),
        props.rooms),



      (props.floor || props.floor === 0) &&
      _react2.default.createElement('span', null,
        _react2.default.createElement('i', { className: 'icon icon-floor', title: props.floorIconTitle }),
        props.floor),



      props.area &&
      _react2.default.createElement('span', null,
        _react2.default.createElement('i', { className: 'icon icon-square', title: props.squareIconTitle }),
        props.area),



      props.status &&
      _react2.default.createElement('span', null,
        props.translate('status') + ': ' + props.status),



      props.parkingSpots ?
      _react2.default.createElement('span', null,
        _react2.default.createElement('i', { className: 'icon icon-parkingSpot', title: props.parkingIconTitle }),
        props.parkingSpots) :

      null));}; // Styles




CellInfoIconsBlock.propTypes = {
  locale: _propTypes2.default.string,
  innerRef: _propTypes2.default.func,
  className: _propTypes2.default.string,
  rooms: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  roomsIconTitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  floor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  floorIconTitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  area: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  squareIconTitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  parkingSpots: _propTypes2.default.number,
  parkingIconTitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  status: _propTypes2.default.string,
  translate: _propTypes2.default.func };exports.default =


CellInfoIconsBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellInfoIconsBlock/CellInfoIconsBlock.js
// module id = 230
// module chunks = 0